export default "/images/2f61ebcfee9cb3ed90fc652a6da742db.avif";